import BaseFormPresenter from "../../../../base/BaseFormPresenter";

class InquiriesFormPresenter extends BaseFormPresenter {
    onChange(value, field) {
        if (field.startsWith("client.")) {
            const clientField = field.split(".")[1];
    
            this.object.client = this.object.client || {};
            this.change.client = {
                ...this.object.client, 
                ...this.change.client, 
            };
    
            this.object.client[clientField] = value;
            this.change.client[clientField] = value;
    
            this.view.setObject(this.object);
        } else {
            super.onChange(value, field);
        }
    }
    
}

export default InquiriesFormPresenter;
